/* unplugin-vue-components disabled */import { render } from "./ModalLoader.vue?vue&type=template&id=d561cf44&scoped=true&ts=true"
import script from "./ModalLoader.vue?vue&type=script&lang=ts"
export * from "./ModalLoader.vue?vue&type=script&lang=ts"

import "./ModalLoader.vue?vue&type=style&index=0&id=d561cf44&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d561cf44"]])

export default __exports__